/**
 * Capture App Code and Name from URL param to hidden fields
 * App Store form only
 */

import getParam from '../../util/getURLParam.js'
import GravityForms from './component.js'

class appStore extends GravityForms{
  constructor() {
    super()
    let form = this.form
    if (form) {
      let appName = getParam('app')
      if (appName) {
        let appNameField = form.querySelector('[id="appName"]')
        let appCodeField = form.querySelector('[id="appCode"]')
        if (appNameField) {
          appNameField.value = appName
        }
        if (appCodeField) {
          let code = appName.toLowerCase().replace(/\s/g, '-')
          appCodeField.value = code
        }
      }
    }
  }
}

new appStore()


// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/appStore.js